// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block-content-preview-container div[class$=\"-view-tabs\"] > div {\n  padding-bottom: 24px;\n  justify-content: center;\n}\n\n.block-content-preview-container div[role=\"tabpanel\"] > :first-child {\n  display: flex;\n  justify-content: center;\n  background-color: transparent;\n  border: none !important;\n  padding: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
